<form [formGroup]="editProfileNameForm" (ngSubmit)="onSubmitEditProfileNameForm()" class="wrapper-edit-info-page">
  <span class="title-edit-page">{{'NEW_TEXT.name' | translate}}</span>
  <span class="subtitle-edit-page">{{'NEW_TEXT.change_your_account_name' | translate}}</span>
  <div class="wrapper-input" [ngClass]="{'error': editProfileNameForm.controls['name'] | formControlErrorMessages: null : formTriedToSubmit}">
    <span class="label-input">{{'NEW_TEXT.name' | translate}}</span>
    <div class="custom-input">
      <input type="text" [maxLength]="50" formControlName="name">
    </div>
    <div *ngIf="editProfileNameForm.controls['name'] | formControlErrorMessages: null: formTriedToSubmit" class="wrapper-error-message">
      <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
      <span>{{editProfileNameForm.controls['name'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
    </div>
    <span class="label-info-input" *ngIf="!(editProfileNameForm.controls['name'] | formControlErrorMessages: null: formTriedToSubmit)">{{editProfileNameForm.controls['name'].value ? (50 - editProfileNameForm.controls['name'].value.length) + ' characters left.' : 'The maximum length of a name is 50 characters.'}}</span>
  </div>
  <div class="buttons-edit-page">
    <button type="button" (click)="onCancelChanges()" class="custom-btn custom-btn--outline">
      <span>{{'NEW_TEXT.cancel' | translate}}</span>
    </button>
    <button type="submit" class="custom-btn custom-btn--primary">
      <span *ngIf="!isSpinnerActive">{{'NEW_TEXT.save_changes' | translate}}</span>
      <tl-spinner *ngIf="isSpinnerActive"></tl-spinner>
    </button>
  </div>
</form>

